import { Box, Stack } from '@mui/material';

import { EarningMechanismAwardSelector } from '@occc-app/offerHelpers/components/earning-mechanism-award-selector';
import { OfferFilter } from '@occc/graphql';
import { AwardType } from '@occc-app/offerHelpers/types';

import { PromocodesConfigureFormValues } from './promocodes-configuration.types';
import { getPromocodesAwardType } from './promocodes-configuration.utils';

type PromocodeConfigurationProps = {
  values: PromocodesConfigureFormValues;
  makeOffersFilter: (search: string) => OfferFilter;
};

export const PromocodesConfiguration = (props: PromocodeConfigurationProps) => {
  const { values, makeOffersFilter } = props;

  return (
    <Stack spacing={2}>
      <Box>
        <EarningMechanismAwardSelector
          buttonTypes={[AwardType.AwardNullable, AwardType.AwardPoints, AwardType.AwardVouchers]}
          fieldNamePrefix='promocodes.'
          makeOffersFilter={makeOffersFilter}
          values={{
            awardType: getPromocodesAwardType(values.promocodes),
          }}
        />
      </Box>
    </Stack>
  );
};
